import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class EventSearchRequest implements ISerialize {
    public From: Date | null;

    public To: Date | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { From?: Date | null; To?: Date | null }) {
        this.From = values.From ?? null;

        this.To = values.To ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"From": ${this.From ? '"' + formatDateIso(this.From).substring(0, 10) + '"' : null}` +
            ',' +
            `"To": ${this.To ? '"' + formatDateIso(this.To).substring(0, 10) + '"' : null}` +
            '}'
        );
    }

    /**
     * Creates an instance of EventSearchRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { From?: Date | null; To?: Date | null }): EventSearchRequest {
        return new EventSearchRequest(values);
    }

    public static _FromServerJson(json: any): EventSearchRequest {
        return new EventSearchRequest({
            From: json.From ? (json.From instanceof Date ? json.From : new Date(json.From + ' 00:00:00')) : null,
            To: json.To ? (json.To instanceof Date ? json.To : new Date(json.To + ' 00:00:00')) : null,
        });
    }

    /**
     * Creates an instance of EventSearchRequest from another instance of EventSearchRequest.
     * @param other The EventSearchRequest you want to clone
     * @returns A cloned EventSearchRequest
     */
    public static FromOther(other: EventSearchRequest): EventSearchRequest {
        return EventSearchRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return EventSearchRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'EventSearchRequest';
}
